import { useMemo } from "react"

import { SimulabStage, useSimulabContext } from "@/entities/simulab"
import HtmlContent from "@/shared/html-content/HtmlContent"
import LockSvgGray from "@/svgs/LockSvgGray"

import { ActiveStageItem } from "./ActiveStageItem"

import "./styles.scss"

type Props = {
    stage: SimulabStage
    showBubbleArrow?: boolean
}

export const StageItem = ({ stage, showBubbleArrow = true }: Props) => {
    const { simulabMessages } = useSimulabContext()

    const stageHasMessages = useMemo(() => {
        return simulabMessages?.messages?.some(message => message.stageId === stage.id)
    }, [simulabMessages])

    const isActiveOrCompleted = stage.completed || stage.current || stageHasMessages

    return (
        <div className="stage">
            {isActiveOrCompleted ? (
                <ActiveStageItem stage={stage} showBubbleArrow={showBubbleArrow} />
            ) : (
                <p className="fs-14 text-gray-200 mb-[10px]">
                    <HtmlContent
                        content={`${stage.title} (${stage.phase})`}
                        renderTag="span"
                        attributes={{ allowedTags: [] }}
                    />{" "}
                    {!stage.completed && !stage.current && !stageHasMessages ? (
                        <LockSvgGray width={12} height={12} />
                    ) : null}
                </p>
            )}
        </div>
    )
}
